import { Component, Input } from '@angular/core';

export interface NmDropdownButtonSettings {
	label: string, // parent button label
	buttons: { // dropdown buttons
		label: string,
		href?: string,
		queryParams?: {[key:string]: string},
		callback?: () => void
	}[]
}

@Component({
	selector: 'nm-dropdown-button',
	templateUrl: './dropdown-button.html'
})
export class NmDropdownButton {
	@Input() settings: NmDropdownButtonSettings;

	public onClick(event, btn) {
		if(btn.callback) {
			btn.callback(event);
		}
	}
}


// WEBPACK FOOTER //
// ./src/widgets/dropdown-button/dropdown-button.ts